import styled from 'styled-components';
import React, { useContext } from 'react';
import { SidebarStateContext } from '../../../providers/MainProviders';
import { Button, Divider, IconButton, useTheme } from '@mui/material';
import { ArrowCircleUp, Menu, MenuOpen } from '@mui/icons-material';
import { AuthContext } from '../../../providers/AuthProvider';
import DateUtils from '../../../shared/DateUtils';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import SidebarNavItem from '../SidebarNavItem/SidebarNavItem';

const FooterContainer = styled.div`
  bottom: 0;
`;

const FooterBar = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  background-color: ${(props) => props.theme.palette.background.paper};
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.1);
`;

const SideUpgrade = styled.div`
  padding: 10px 20px 30px 20px;
  text-align: center;
`;

const CustomDivider = styled(Divider)``;

const SidebarFooter = () => {
  const { expanded, setSidebarExpanded } = useContext(SidebarStateContext);
  const { validUntil } = useContext(AuthContext);
  const theme = useTheme();

  const vu = validUntil();
  const currentLanguage = i18n.language;
  const { t } = useTranslation();

  const days = DateUtils.getDaysUntil(vu);

  return (
    <FooterContainer>
      {vu && expanded && (
        <SideUpgrade>
          <>
            {days !== null && days >= 0 ? (
              <p>
                <span>{t('freebie_expires')}</span>
                <strong style={{ color: theme.palette.primary.main }}>
                  {t('freebie_days', { count: days })}
                </strong>
              </p>
            ) : (
              <p>{t('freebie_expired')}</p>
            )}
          </>
          <Button
            variant="contained"
            target="_blank"
            href={t('freebie_link')}
            sx={{ mt: theme.spacing(0.5) }}
          >
            {t('upgrade_now')}
          </Button>
        </SideUpgrade>
      )}
      {vu && !expanded && (
        <>
          <CustomDivider />
          <SidebarNavItem
            text={t('nav_freebie')}
            to={t('freebie_link')}
            tooltip={t('nav_freebie')}
            icon={<ArrowCircleUp fontSize="small" />}
          />
        </>
      )}
      <FooterBar>
        <IconButton
          style={{ color: theme.palette.primary.light }}
          aria-label="menu"
          onClick={() => setSidebarExpanded(!expanded)}
          sx={{ color: theme.palette.text.primary }}
        >
          {expanded ? <MenuOpen fontSize="small" /> : <Menu fontSize="small" />}
        </IconButton>
      </FooterBar>
    </FooterContainer>
  );
};

export default SidebarFooter;
